/// *****************Draw rectaagle withLine *****************

const rectangle3SidedDrawing = (fabricCanvas, fabric) => {
    let isDrawingRect = false
    let origX, origY
    let lines = []
    let lineCounter = 0
    let isDrawing = false

    fabricCanvas.on('mouse:down', (o) => {
        if (!fabricCanvas.isDrawingRectangle3Sided || lineCounter !== 0) return

        let pointer = fabricCanvas.getPointer(o.e)
        const activeObject = fabricCanvas.getActiveObject()

        if (!isDrawing && activeObject && activeObject.type === 'group') {
            // The click is on the existing circle, it will be selected
            return
        } else {
            isDrawingRect = true
            isDrawing = true
            origX = pointer.x
            origY = pointer.y

            for (let i = 0; i < 4; i++) {
                lines[i] = new fabric.Line([0, 0, 0, 0], {
                    strokeWidth: 2,
                    stroke: window.globalColor,
                    originX: 'left',
                    originY: 'top',
                    selectable: false,
                    evented: false,
                    visible: i !== 1,
                    strokeUniform: true
                })
                fabricCanvas.add(lines[i])
            }
            fabricCanvas.requestRenderAll()
        }
    })

    fabricCanvas.on('mouse:move', (o) => {
        if (!isDrawingRect) return

        let pointer = fabricCanvas.getPointer(o.e)

        // Update the positions of the lines to form a rectangle
        lines[0].set({ x1: origX, y1: origY, x2: pointer.x, y2: origY })
        lines[1].set({ x1: pointer.x, y1: origY, x2: pointer.x, y2: pointer.y })
        lines[2].set({ x1: pointer.x, y1: pointer.y, x2: origX, y2: pointer.y })
        lines[3].set({ x1: origX, y1: pointer.y, x2: origX, y2: origY })

        fabricCanvas.requestRenderAll()
    })

    fabricCanvas.on('mouse:up', () => {
        if (!isDrawingRect) return

        isDrawingRect = false
        lineCounter = 0

        let lineGroup = new fabric.Group(lines, {
            type: 'group',
            originX: 'left',
            originY: 'top',
            selectable: false,
            evented: true,
            strokeUniform: true
        })

        // Add the group to the canvas
        fabricCanvas.add(lineGroup)

        // Remove individual lines from the canvas
        lines.forEach((line) => fabricCanvas.remove(line))

        // Clear the lines array
        lines = []

        isDrawing = false
        lineGroup.set({ selectable: true }) // Now the circle can be selected
        fabricCanvas.requestRenderAll()
        fabricCanvas.fire('object:modified')

        fabricCanvas.isDrawingRectangle3Sided = true
    })
}

export default rectangle3SidedDrawing
/// *****************Draw rectaagle withLine *****************
